import styled from 'styled-components';

export const Plan = styled.div`
  background: white;
  min-height: 100%;
`
